import React from "react";

interface SearchIconProps {
	className?: string;
	ariaHidden?: boolean;
}

export function SearchIcon({
	className = "",
	ariaHidden = true,
}: SearchIconProps) {
	return (
		<span className={className} aria-hidden={ariaHidden}>
			{/* biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon, hidden via the parent span's aria-hidden */}
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M19.5 19.5L15.5 15.5M17 10.5C17 14.0899 14.0899 17 10.5 17C6.91015 17 4 14.0899 4 10.5C4 6.91015 6.91015 4 10.5 4C14.0899 4 17 6.91015 17 10.5Z"
					stroke="#27313F"
					strokeWidth="2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</svg>
		</span>
	);
}
